import { AnyAction } from 'redux'

export interface FlightInfo {
  airline: string
  code: string
  departure: number
  departure_tz: string
}

export interface NextFlightInfo {
  airport: string
  at_airport: string
  at_airport_tz: string
}

export interface ImportantTripInfo {
  auto_boarding: boolean
  mobile_check_in: boolean
  has_return_flight: boolean
  theme: number
  first_flight_info: FlightInfo | null
  next_flight_info: NextFlightInfo | null
}

export const defaultImportantTripInfo: ImportantTripInfo = {
  auto_boarding: false,
  mobile_check_in: false,
  theme: 0,
  has_return_flight: true,
  first_flight_info: null,
  next_flight_info: null,
}

export const SET_IMPORTANT_TRIP_INFO = 'SET_IMPORTANT_TRIP_INFO'
export const setImportantTripInfo = (data: ImportantTripInfo): AnyAction => ({
  type: SET_IMPORTANT_TRIP_INFO,
  data,
})

export const getFlyMoreUnlocks = (state: ImportantTripInfo): boolean =>
  state.theme === 14 && !state.has_return_flight

const importantTripInfoReducer = (
  currentState: ImportantTripInfo = defaultImportantTripInfo,
  action: AnyAction,
): ImportantTripInfo => {
  switch (action.type) {
    case SET_IMPORTANT_TRIP_INFO:
      return action.data
    default:
      return currentState
  }
}

export default importantTripInfoReducer
